
import React, { useEffect, useState, useCallback } from "react";
import { useDeviceState } from "../utils/globalStates";
import Snackbar from "@mui/material/Snackbar";
import { Button } from "@mui/material";

export default function Listeners() {
  const [gdprOpen, setGdprOpen] = useState(false);
  const deviceState = useDeviceState((state) => state);
  const { setMobile, setDeviceWidth } = deviceState;

  const checkIfMobile = useCallback(() => {
    if (window.innerWidth > window.innerHeight) {
      setMobile(false);
    } else {
      setMobile(true);
    }
    setDeviceWidth(window.innerWidth);
  }, [setMobile, setDeviceWidth]);

  useEffect(() => {
    const onResize = () => checkIfMobile();

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [checkIfMobile]);

  const gdprCheck = () => {
    if (
      localStorage.getItem("gdpr") === null ||
      localStorage.getItem("gdpr") === undefined ||
      localStorage.getItem("gdpr") === "false" ||
      localStorage.getItem("gdpr") === ""
    ) {
      setGdprOpen(true);
    }
  };

  const onGdprClose = () => {
    localStorage.setItem("gdpr", "true");
    setGdprOpen(false);
  };

  useEffect(() => {
    checkIfMobile();
  }, [checkIfMobile]);

  useEffect(() => {
    gdprCheck();
  }, []);

  return (
    <>
      <Snackbar
        open={gdprOpen}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "#44a99a",
            color: "#39393c",
            fontSize: "14px",
            fontWeight: 600,
            textAlign: "left",
            "@media (min-width: 600px)": {
              marginRight: "24px !important",
              maxWidth: "360px",
            },
            "@media (min-width: 900px)": {
              maxWidth: "500px",
            },
          },
        }}
        message="We use cookies to improve your experience on our site. By using our site, you agree to our use of cookies."
        action={
          <React.Fragment>
            <Button variant="text" onClick={onGdprClose} color="inherit">
              Accept
            </Button>
          </React.Fragment>
        }
      />
    </>
  );
}
